import { GroupChannel } from '@sendbird/chat/groupChannel';
import { isNil } from 'lodash';

import { isExternalChannel } from '~/lib/util/chat/chat.utils';
import { ChatChannelTab } from '~/lib/util/chat/chatChannel.util';
import { Path } from '~/routes/constants';

export const getDefaultChannel = (channels: GroupChannel[]) =>
  channels ? channels[0] : null;

export const getChannelTabIndexToChannelsMapper = (
  channels: GroupChannel[],
): Record<ChatChannelTab, GroupChannel[]> => ({
  [ChatChannelTab.EXTERNAL]: (channels ?? []).filter((channel: GroupChannel) =>
    isExternalChannel(channel.url),
  ),

  [ChatChannelTab.INTERNAL]: (channels ?? []).filter(
    (channel: GroupChannel) => !isExternalChannel(channel.url),
  ),
});

interface onChannelTabChangeHandlerProps {
  channels: GroupChannel[];
  channelTabIndex: number;
  //@ts-expect-error using interface from useHistory API
  history: History<unknown>;
  patientId: string;
  setChannelTabIndex: (index: number) => void;
  setSelectedChannel: (channel: GroupChannel) => void;
  tab: number;
}

export const onChannelTabChangeHandler = ({
  channels,
  channelTabIndex,
  history,
  patientId,
  setChannelTabIndex,
  setSelectedChannel,
  tab,
}: onChannelTabChangeHandlerProps) => {
  const channelTabIndexToChannelsMapper =
    getChannelTabIndexToChannelsMapper(channels);

  const defaultChannel = getDefaultChannel(
    channelTabIndexToChannelsMapper[tab],
  );

  const userNotSelectingSameTab = channelTabIndex !== tab;

  if (!isNil(defaultChannel) && userNotSelectingSameTab) {
    if (!isNil(defaultChannel)) {
      history.push(
        `${Path.MAUD_PATIENTS}/${patientId}/messages?channelUrl=${defaultChannel.url}`,
      );
    }
    setSelectedChannel(null);
    setChannelTabIndex(tab);
  }
};
